import * as artefacts from './index'

export default {
  components: Object.assign({}, artefacts),
  props: ['attributes'],
  methods: {
    existComponent (type) {
      return (type.toLowerCase() in this.$options.components)
    }
  }
}
